import { Image } from '@dixa/lib-shared-habla';
import type { MessageFile } from 'lib-shared-types-api';

type InstagramStoryImageProps = {
  readonly attachment: MessageFile;
  readonly onError: () => void;
};

export const InstagramStoryImage = ({
  attachment: { url, pretty_name },
  onError,
}: InstagramStoryImageProps): JSX.Element => {
  return <Image src={url} alt={pretty_name} onError={onError} />;
};
